export default "__VITE_ASSET__VhXKjC8P__"